<template>
  <div class="indicators-panel">
    <div class="header">
      <img :src="data.header.right" alt="">
    </div>
    <div class="open-close" @click="onClickedClose()">
      <div class="close">{{data.dictionary.closeIndicators}}</div>
    </div>
    <div class="inner">
      <div class="title-clear-bar">
        <h2 class="title">{{data.dictionary.indicatorsTitle}}</h2>
        <div class="clear-all" v-on:click="onClearAll"><span class="x">✕</span> <span class="text">Clear All</span></div>
      </div>
      <div class="indicator" v-for="indicator in data.indicators" :key="indicator.id">
        <h3>{{indicator.title}}</h3>
        <img :src="indicator.image" alt="">
        <!-- <div class="description">{{indicator.description}}</div> -->
        <toggle 
          href="" 
          class="value" 
          v-on:click="onClickedToggle" 
          v-for="value in indicator.values" 
          :key="indicator.id+value.id" 
          :title="value.text" 
          :indicator-id="indicator.id" 
          :toggle-id="value.id"
          :ref="'toggle'+indicator.id+value.id"
          :color="value.color"
          >
        </toggle>
        
      </div>
      
    </div>
    <div class="map-venues">
      <mapbox :data="data" v-on:click-venue="onClickVenueMap"></mapbox>
      <div class="venues">
        <h2>{{data.dictionary.venuesTitle}}</h2>
        <toggle 
          v-on:click="onClickVenueToggle" 
          v-for="venue in data.venues" 
          :key="venue.id" 
          :title="venue.title"
          indicator-id="venues"
          :toggle-id="venue.id"
          :ref="'venue'+venue.id"
          color="#888888"
          ></toggle>
      </div>
    </div>
  </div>
</template>

<script>
import Toggle from './Toggle.vue';
import Mapbox from './Mapbox.vue';

export default {
  name: 'indicators',
  props: {
    data: {}
  },
  data() {
    return {
      selectionData: {}
    }
  },
  components: {
    toggle: Toggle,
    mapbox: Mapbox
  },
  methods: {
    onClearAll() {
      for(const c of this.$children) {
        if(c.$options._componentTag == 'toggle') {
          c.clear();
        }
      }
      this.selectionData = {};
      this.$emit('onSelectionChange', this.selectionData);
    },
    onClickedToggle(toggleData) {
      if(toggleData.active) {
        if(!this.selectionData[toggleData.indicatorId]) {
          this.selectionData[toggleData.indicatorId] = {};
        }
        this.selectionData[toggleData.indicatorId][toggleData.toggleId] = true;
      } else {
        delete this.selectionData[toggleData.indicatorId][toggleData.toggleId];
      }
      
      if(this.selectionData[toggleData.indicatorId] && Object.keys(this.selectionData[toggleData.indicatorId]).length == 0) {
        delete this.selectionData[toggleData.indicatorId];
      }
      this.$emit('onSelectionChange', this.selectionData);

    },
    onClickedClose() {
      this.$emit('onClickedClose');
    },
    onClickVenueMap(id) {
      if(this.$refs['venue'+id]) {
        
        this.$refs['venue'+id][0].onClick();
      } else {
        alert('venue toggle ' + id + ' is missing');
      }
      
    },
    onClickVenueToggle(toggleData) {
      if(toggleData.active) {
        if(!this.selectionData.venues) {
          this.selectionData.venues = {};
        }
        this.selectionData.venues[toggleData.toggleId] = true;
      } else {
        delete this.selectionData.venues[toggleData.toggleId];
      }

      if(this.selectionData.venues && Object.keys(this.selectionData.venues).length == 0) {
        delete this.selectionData.venues;
      }

      this.$emit('onSelectionChange', this.selectionData);
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  // @import '../../global';
  
  .indicators-panel {
    padding:0.75rem;
    .header {
      img {
        width:calc(100% - 1rem);
        height: auto;
        @media (max-width:979px) {
          display:none;
        }
      }
    }
    .venues {
      padding-bottom: 3rem;
    }
    .clear-all {
      margin-right:1rem;
      font-weight: bold;
      cursor: pointer;
      display: inline-block;
      align-self: flex-end;
      margin-bottom: 0.5rem;
      .x {
        opacity:0;
      }
      .text {
        padding: 1px 4px;
        border-radius: 3px;
        letter-spacing: 0.05em;
        background-color: #90f8bc;
      }
      &:hover {
        .x {
          opacity: 1;
        }
        .text {
          background-color: #31d677;
        }
      }
    }
    .open-close {
      display: none;
    }
    @media (max-width: 980px) {
      
      padding-left:2rem;
      margin-left:2rem;
      // width: 30rem;

      box-shadow: 0 0 3rem rgba(0,0,0,0.25);
      &.open {
        transform: translate3d(0,0,0);
      }
      .open-close {
        padding:0.25rem 0.5rem;
        display:inline-block;
        transform-origin:  0% 0%;
        transform:rotate(90deg);
        // text-transform: uppercase;
        position: fixed;
        z-index: 1000;
        cursor: pointer;

                // padding:1px 4px ;
        // margin-right:1rem;
        font-weight:bold;
        border-radius:3px;
        letter-spacing: 0.05em;
      }
    }
    height:100vh;
    overflow-y:scroll;
    background-color: white;
    .inner {
      // padding:0.5rem;
      display:grid;
      @media (min-width:980px) {
        grid-template-columns: 1fr 1fr 1fr;
      }
      grid-auto-flow: dense;

      .title-clear-bar {
        grid-column: 1 / -1;
        font-size: 0.8rem;
        text-transform: uppercase;
        display: flex;
        justify-content: space-between;
        // margin-top: 2rem;
        margin-bottom: 0.25rem;
      }
      .indicator {
        border-top:0.1rem solid;
        padding-bottom:1rem;
        margin-right:1rem;

        h3 {
          margin-top:0.15rem;
        }
        
        .description {
          margin-bottom: 1rem;
        }
        img {
          width:100%;
          max-width:25rem;
          display:block;
          height:auto;
        }
      }
    }
  }
</style>
